import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Admin/Sidebar";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { ToastContainer, toast } from "react-toastify";

const AdminOrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [toggleValue, setToggleValue] = useState(false);

  // Authentication
  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const [orderDetails, setOrderDetails] = useState();

  useEffect(() => {
    if (id && token) {
      getOrderDetails();
    }
  }, [id, token]);

  const getOrderDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}order/admin/${id}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const order = response.data;
      setOrderDetails(order);
    } catch (error) {
      console.error("Error" + error);
    }
  };

  const orderDate = new Date(orderDetails?.createdAt);
  const formattedOrderDate = orderDate.toLocaleDateString("en-IN"); // Format as DD-MM-YYYY

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [isModalOpenforstatus, setIsModalOpenforstatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [pendingProduct, setPendingProduct] = useState(null);

  useEffect(() => {
    if (selectedProduct) {
      // You can run any code when selectedProduct changes
      getOrderDetails();
    }
  }, [selectedProduct]);
  const handleProductClick = (item) => {
    setSelectedProduct(item);
  };

  const handleProductStatusChnge = (productId, orderType, orderId) => {
    // Save the selected status and open the modal
    setSelectedStatus(orderType);
    setPendingProduct({ productId, orderType, orderId });
    setIsModalOpenforstatus(true);
  };

  const confirmStatusChange = async () => {
    if (!pendingProduct) return; // Guard clause

    const { productId, orderType, orderId } = pendingProduct;

    try {
      // Optimistically update the UI
      const previousSelectedProduct = { ...selectedProduct };
      const previousOrderDetails = { ...orderDetails };

      setOrderDetails((prevState) => ({
        ...prevState,
        products: prevState.products.map((product) =>
          product.id === productId
            ? {
              ...product,
              orderProduct: {
                ...product.orderProduct,
                orderType: orderType,
              },
            }
            : product
        ),
      }));

      if (selectedProduct?.id === productId) {
        setSelectedProduct((prevSelectedProduct) => ({
          ...prevSelectedProduct,
          orderProduct: {
            ...prevSelectedProduct.orderProduct,
            orderType: orderType,
          },
        }));
      }

      // Call the API
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}order/updateOrderType`,
        { productId: productId, orderType, orderId },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const message = response.data.message;
      const status = response.data.status;

      if (status === "error") {
        toast.warn(message);
        setOrderDetails(previousOrderDetails);
        setSelectedProduct(previousSelectedProduct);
      } else {
        toast.success(message); // Show success message here
        getOrderDetails(); // Refresh order details
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      closeModalforstatus(); // Always close the modal
    }
  };

  const closeModalforstatus = () => {
    setIsModalOpenforstatus(false);
    setSelectedStatus("");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          ></Icon.ArrowRight>
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <h5>Saller Orders Details</h5>
              <h6 className="text-muted">View and change your product order status</h6>
            </div>

            {/* Dashboard content start */}
            {
              orderDetails &&
              <div className="col-12 mt-5">
                <div className="container-fluid">
                  <div className="orderdetails bg-light">
                    <div className="row">
                      <div className="col-sm-4 col-md-4">
                        <h3>Delivery Address</h3>
                        <h4>{orderDetails.name}</h4>
                        <p>{`${orderDetails.city}, ${orderDetails.district}, ${orderDetails.houseNo} ${orderDetails.address} - ${orderDetails.pincode}, ${orderDetails.state}`}</p>
                        <p>
                          <strong>Phone number :</strong>{" "}
                          {orderDetails.phone_no}
                        </p>
                      </div>
                      <div className="col-sm-4 col-md-4">
                        <h3>Order Number</h3>
                        <p>#{orderDetails.orderNumber}</p>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <h4>Order Method</h4>
                        <p>{orderDetails.method}</p>
                      </div>
                      <div className="col-sm-2 col-md-2">
                        <h4>Order Date</h4>
                        <p>{formattedOrderDate}</p>
                      </div>
                    </div>
                  </div>
                  <div className="border-top border-1 my-3 p-3">
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered">
                        <thead className="table-light text-center">
                          <tr>
                            <th>SQ</th>
                            <th>Title</th>
                            <th>SKU</th>
                            <th>Quant</th>
                            <th>Price</th>
                            <th>Status</th>
                            <th>Change status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            orderDetails.products.map((item, i) => {

                              const orderProduct = item.orderProduct;

                              return (
                                <tr key={i}>
                                  <td className="text-center">
                                    <img
                                      className="img-responsive object-fit-contain"
                                      style={{ width: "50px", height: "50px" }}
                                      src={
                                        process.env.REACT_APP_API_URL +
                                        process.env.REACT_APP_product_IMAGE_URL +
                                        item.image[0]
                                      }
                                      alt="sell item"
                                    />
                                  </td>
                                  <td style={{ fontSize: "12px" }}>{item.title}</td>
                                  <td>{item.sku}</td>
                                  <td className="text-center">{orderProduct.quantity}</td>
                                  <td className="text-center">₹{item.update_price}</td>
                                  <td className="text-center">{orderProduct.orderType}</td>
                                  <td className="text-center"><Button variant={`outline-dark ${selectedProduct?.id === item.id && 'active'}`} onClick={() => handleProductClick(item)}><Icon.ArrowRight /></Button></td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Edit product status section start */}
                  {selectedProduct && (
                    <div className="mt-10">
                      <h3>Product Details</h3>
                      <table className="table table-sm table-bordered">
                        <thead className="text-center">
                          <tr>
                            <th>ID</th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>SKU</th>
                            <th>Price</th>
                            <th>Order Status</th>
                            <th>Return Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{selectedProduct.id}</td>
                            <td>
                              <img
                                src={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_product_IMAGE_URL}${selectedProduct.image[0]}`}
                                alt="product"
                                style={{
                                  width: "50px",
                                  height: "50px"
                                }}
                                className="object-fit-contain"
                              />
                            </td>
                            <td>{selectedProduct.title}</td>
                            <td>{selectedProduct.sku}</td>
                            <td>₹{selectedProduct.update_price}</td>
                            <td>
                              <select
                                className="form-control"
                                onChange={(e) =>
                                  handleProductStatusChnge(
                                    selectedProduct.id,
                                    e.target.value,
                                    selectedProduct.orderProduct.orderid
                                  )
                                }
                                value={
                                  selectedProduct.orderProduct?.orderType ||
                                  "initiate"
                                }
                                disabled={
                                  ["cancelled", "Return Approved", "Return Cancelled"].includes(
                                    selectedProduct?.orderProduct?.orderType
                                  )
                                }
                              >
                                <option value="initiate">Initiate</option>
                                <option value="shipped">Shipped</option>
                                <option value="success">Success</option>
                                <option value="delivered">Delivered</option>
                                <option value="cancelled">Cancelled</option>
                                <option value="Return Approved">Return Approved</option>
                                <option value="Return Cancelled">Return Cancelled</option>
                              </select>
                            </td>
                            <td className="text-center">
                              <span
                                className={`badge rounded-pill ${selectedProduct.orderProduct
                                  ?.returnType === "pending"
                                  ? "text-bg-warning"
                                  : "text-bg-success"
                                  }`}
                              >
                                {selectedProduct.orderProduct?.returnType ||
                                  "pending"}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* Edit product status section end */}

                  {/* Status change modal */}
                  <Modal
                    show={isModalOpenforstatus}
                    onHide={closeModalforstatus}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Confirm Status Update</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to update the status to "
                      <strong>{selectedStatus}</strong>"?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={closeModalforstatus}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={confirmStatusChange}>
                        Confirm
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  {/* Status change modal */}
                </div>
              </div>
            }
            {/* Dashboard content end */}
          </div>
        </div>
      </div>

      {/* Toast */}
      <ToastContainer theme="dark" autoClose={2000} />
      {/* Toast */}
    </div>
  );
};

export default AdminOrderDetails;
